<template>
  <dashboard-page title="Detalhes do requerimento">
    <div class="content">
    <b-container fluid>
      <b-row>
        <b-col lg="12">
          <card>
            <!--Card Header-->
            <h3 slot="header" class="mb-0">
             {{ issuesParameter.typelabel }}
            <b-col cols="12" class="text-right">
               <router-link :to="{ path: '/issues/index' }">
                  <base-button size="sm" type="neutral">Fechar</base-button>
              </router-link>
              </b-col>
            </h3>
           
            <!--Card Body-->
            <b-row>
              <b-col lg="12">
                <!-- Grid system -->
                <b-row class="row-example">
                  <b-col sm> Tipo: {{ issuesParameter.typelabel }}</b-col>
                </b-row>
                <b-row class="row-example pt-3">
                  <b-col sm> Comentário: {{ issuesParameter.details }}</b-col>
                </b-row>
                <b-row class="row-example pt-3">
                  <b-col sm>
                    Data: {{ formatIssuesDate(issuesParameter.date) }}</b-col
                  >
                </b-row>
                <b-row class="row-example pt-3">
                  <b-col lg="3" md="3">
                    Status:
                    <div class="pt-3">
                      <select
                        :disabled="!setPlaceIssuesStatusRoles"
                        v-on:change="changeStatusItemList($event)"
                        v-model="issuesParameter.status"
                        class="form-control"
                      >
                        <option
                          v-for="option in selectOptionsStatus"
                          :key="option.id"
                          :label="option.status"
                          :value="option.id"
                        ></option>
                      </select>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pt-4">
                  <b-col lg="12">
                    <el-tabs v-model="activeName" @tab-click="handleClickTabs">
                      <el-tab-pane label="Informações" name="first"
                        ><p v-html="info"></p
                      ></el-tab-pane>
                      <el-tab-pane label="Arquivos" name="second">
                        <issues-details-docs-list
                          :idIssues="issuesParameter.id"
                        ></issues-details-docs-list
                      ></el-tab-pane>
                      <el-tab-pane
                        :lazy="true"
                        label="Acompanhamento"
                        name="third"
                        ><issues-details-messages
                          :loadingMessages="loadingMessages"
                          :messages="messages"
                          :idIssues="issuesParameter.id"
                          :userIssues="issuesParameter.user"
                        ></issues-details-messages
                      ></el-tab-pane>
                    </el-tabs>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
  </dashboard-page>
</template>
<script>
import swal from "sweetalert2";
import bocapioService from "@/services/nodejs/index";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import IssuesDetailsDocsList from "./IssuesDetails/IssuesDetailsDocsList";
import IssuesDetailsMessages from "./IssuesDetails/IssuesDetailsMessages";
import IssuesList from "./IssuesList.vue"
import { Select, Option, Tabs, TabPane } from "element-ui";
import { mapGetters } from "vuex";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    IssuesDetailsDocsList,
    IssuesDetailsMessages,
    RouteBreadCrumb,
    IssuesList
  },
  data() {
    return {
      setPlaceIssuesStatusRoles: null,
      validated: false,
      tabAcompanhamentoClicked: false,
      submitButtonText: "Enviar",
      showAlert: false,
      loadingMessages: false,
      disableSubmitButton: false,
      info: "",
      activeName: "first",
      issuesParameter: {
        label: "",
        typelabel: "",
        id: 0,
        status: "",
        date: "",
        details: "",
        type: "",
        user: {}
      },
      messages: [],
      selectOptionsStatus: []
    };
  },
  created() {
    console.log("parametros", this.$route);
    if (this.$route.params.issues) {
      this.issuesParameter = this.$route.params.issues;
      this.issuesParameter.typelabel = this.$route.params.issues.issues_type.label;
      this.issuesParameter.date = this.$route.params.issues.date;
      this.issuesParameter.id = this.$route.params.issues.id;
      this.issuesParameter.details = this.$route.params.issues.details;
      this.issuesParameter.status = this.$route.params.issues.status;
      this.issuesParameter.type = this.$route.params.issues.type;
      this.issuesParameter.user = this.$route.params.issues.user;

      this.getAllMessagesByIssuesId(this.issuesParameter.id);
      this.getAllStatusRequerimentos();
      this.getDetalhesTipoRequerimento();
    } else {
      this.$router.push("/issues");
      return;
    }
  },
  mounted() {
    this.roles.issues ? this.getUserRoles() : "";
  },

  computed: {
    ...mapGetters([
      "roles"
      // ...
    ])
  },
  methods: {
    handleClickTabs(tab, event) {},

    getAllMessagesByIssuesId(idIssues) {
      this.loadingMessages = true;
      bocapioService
        .getMessagesByIssuesId(idIssues)
        .then(rsp => {
          console.log("resposta getAllMessagesByIssuesId ", rsp.data);
          this.messages = rsp.data;
          this.loadingMessages = false;
        })
        .catch(erro => {
          console.log(erro);
          this.loadingMessages = false;
        });
    },

    changeStatusItemList(event) {
      if (event.target.options.selectedIndex > -1) {
        var id = event.target.value;
        var label =
          event.target.options[event.target.options.selectedIndex].label;
        this.updateStatusRequerimento(this.issuesParameter.id, id);
      }
    },

    updateStatusRequerimento(issuesId, idStatus) {
      bocapioService
        .updateStatusRequerimento(issuesId, idStatus)
        .then(rsp => {
          console.log("resposta updateStatusRequerimento ", rsp.data);
          this.showSwal(
            "Sucesso!!",
            "Status de Requerimento atualizado com sucesso !!",
            "primary",
            "success"
          );
        })
        .catch(erro => {
          this.$router.push("/issues");
          this.showSwal(
            "Erro!!",
            "Tente novamente mais tarde.",
            "warning",
            "warning"
          );
        });
    },

    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon
      });
    },

    async firstFormSubmit() {
      this.submitButtonText = "Enviando...";
      this.disableSubmitButton = true;
      this.showAlert = false;
      bocapioService
        .cadastrarRequerimento(
          this.form.issuesComentary,
          this.form.selectedTypeIssues
        )
        .then(rsp => {
          console.log("resposta cadastrarRequerimento ", rsp.data);
          this.submitButtonText = "Enviando...";
          this.disableSubmitButton = false;
          this.$router.push("/issues");
        })
        .catch(() => {
          this.submitButtonText = "Enviar";
          this.showAlert = true;
          this.disableSubmitButton = false;
        });
    },

    changeSelectItem() {
      var issuesType = this.issuesSelectOptions.find(issuesElem => {
        return issuesElem.id == this.form.selectedTypeIssues;
      });
      this.infoIssues = issuesType.description;
      this.showInitialTextInfoIssues = false;
    },

    formatIssuesDate(oldData) {
      let d = new Date(oldData);
      let n = d.toLocaleString();
      return n;
    },

    getAllStatusRequerimentos() {
      bocapioService
        .getAllStatusRequerimentos()
        .then(rsp => {
          console.log("resposta getAllStatusRequerimentos ", rsp.data);
          this.selectOptionsStatus = rsp.data;
        })
        .catch(erro => {
          console.log(erro);
        });
    },

    getDetalhesTipoRequerimento() {
      bocapioService
        .getDetalhesTipoRequerimento(this.issuesParameter.type)
        .then(rsp => {
          console.log("resposta getDetalhesTipoRequerimento ", rsp.data);
          if (rsp.data) {
            this.info = rsp.data.description;
          }
        })
        .catch(erro => {
          console.log(erro);
        });
    },

    getUserRoles() {
      this.setPlaceIssuesStatusRoles = this.roles.issues.find(
        role => role.action == "set_place_issues_status"
      );
      this.setFilesIssuesStatusRoles = this.roles.issues.find(
        role => role.action == "set_files_issues_status"
      );
    }
  }
};
</script>
<style></style>
